
const DataTableEnumType = {
    HCHB_PAYOR_TYPE : 'HCHB_PAYOR_TYPE',
    SECTION:'SECTION',
    MITEM:'MITEM',
    CLIENT:'CLIENT',
    USER:"USER",
    BULK_UPLOAD:"BULK_UPLOAD",
    ACTIVITY_LOG:"ACTIVITY_LOG",
    GROUP_CONFIGURATION : 'GROUP_CONFIGURATION' ,
    WORKFLOW:"WORKFLOW",
    SHIFT_TYPE:"SHIFT_TYPE"
}

Object.freeze(DataTableEnumType);

export default DataTableEnumType;